export * from './useGroupDetail2';
